
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("5TFDw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $44b262f5658072be$var$_jquery = $44b262f5658072be$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $44b262f5658072be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $44b262f5658072be$var$screencheck = function screencheck(mediasize) {
    var screensize = window.matchMedia("(max-width:" + mediasize + "px)");
    return !!screensize.matches;
};
var $44b262f5658072be$var$scrollToAnchor = function scrollToAnchor(anchor) {
    if ((0, $44b262f5658072be$var$_jquery["default"])(anchor).length > 0) {
        (0, $44b262f5658072be$var$_jquery["default"])(".join-steps li").removeClass("active");
        var offsetTop = (0, $44b262f5658072be$var$_jquery["default"])(anchor).offset().top;
        (0, $44b262f5658072be$var$_jquery["default"])('.join-steps a[href="' + anchor + '"]').parent().addClass("active");
        var aktScrollPos = (0, $44b262f5658072be$var$_jquery["default"])(document).scrollTop();
        // Version 2: fixed Header gar nicht erst einblenden
        if (aktScrollPos > offsetTop) fixed = false;
        (0, $44b262f5658072be$var$_jquery["default"])(".join-steps li").each(function() {
            var hash = (0, $44b262f5658072be$var$_jquery["default"])(this).find("a").attr("href");
        });
        (0, $44b262f5658072be$var$_jquery["default"])("html, body").stop().animate({
            scrollTop: offsetTop - 40
        }, 300, function() {
            // Version 2: fixed Header gar nicht erst einblenden: Wert zurücksetzen
            window.setTimeout(function() {
                fixed = true;
            }, 300);
        });
    }
};
var $44b262f5658072be$var$init = module.exports.init = function init() {
    // Footer Dropdown ----------------------------------------------------------
    (0, $44b262f5658072be$var$_jquery["default"])(".footer-col h5").on("click", function() {
        if ($44b262f5658072be$var$screencheck(567)) {
            var accordion = (0, $44b262f5658072be$var$_jquery["default"])(this).next("ul");
            if ((0, $44b262f5658072be$var$_jquery["default"])(accordion).is(":visible")) {
                (0, $44b262f5658072be$var$_jquery["default"])(this).removeClass("nav-open");
                (0, $44b262f5658072be$var$_jquery["default"])(accordion).slideUp("normal");
            }
            (0, $44b262f5658072be$var$_jquery["default"])(".footer-col h5").removeClass("nav-open");
            (0, $44b262f5658072be$var$_jquery["default"])(".footer-col ul").slideUp("normal");
            (0, $44b262f5658072be$var$_jquery["default"])(this).addClass("nav-open");
            (0, $44b262f5658072be$var$_jquery["default"])(accordion).slideDown("normal");
        }
    });
    if ((0, $44b262f5658072be$var$_jquery["default"])(".footer-links a").length > 0) (0, $44b262f5658072be$var$_jquery["default"])(".footer-links a").off("click").on("click", function(event) {
        if ((0, $44b262f5658072be$var$_jquery["default"])(this).attr("href")) {
            var linkPath = (0, $44b262f5658072be$var$_jquery["default"])(this).attr("href").split("/");
            if (linkPath.length > 0) {
                var anchor = linkPath.pop();
                if (anchor.substring(0, 1) === "#" && (0, $44b262f5658072be$var$_jquery["default"])(anchor).length > 0) {
                    event.preventDefault();
                    $44b262f5658072be$var$scrollToAnchor(anchor);
                }
            }
        }
    });
};

});


//# sourceMappingURL=footer.module.4e32cc9d.js.map
